"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import m from "../components/Icon/SvgIcon.js";
const t = (a) => /* @__PURE__ */ o(
  m,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...a,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.375 16.079a2.377 2.377 0 0 0 2.375-2.375V8.625a2.377 2.377 0 0 0-2.375-2.375H8.07a2.38 2.38 0 0 0-2.375 2.375v5.079a2.38 2.38 0 0 0 2.375 2.375zm-12.75 2.446h10.447c.856 0 1.591-.488 1.966-1.196H8.07a3.63 3.63 0 0 1-3.625-3.625V8.813a1.82 1.82 0 0 0-1.195 1.703v5.634a2.377 2.377 0 0 0 2.375 2.375M8.07 5h10.305A3.63 3.63 0 0 1 22 8.625v5.079c0 1.628-1.086 2.992-2.565 3.448-.386 1.504-1.742 2.623-3.363 2.623H5.625A3.63 3.63 0 0 1 2 16.15v-5.634a3.064 3.064 0 0 1 2.646-3.027C5.125 6.049 6.471 5 8.07 5m5.153 3.256a1.032 1.032 0 1 0 0 2.061 1.032 1.032 0 0 0 0-2.061m0 3.313a2.283 2.283 0 0 1-2.282-2.281 2.284 2.284 0 0 1 2.282-2.282 2.284 2.284 0 0 1 2.282 2.282 2.283 2.283 0 0 1-2.282 2.28m3.29 4.002a.625.625 0 0 1-.624-.625V13.77a.807.807 0 0 0-.807-.805h-3.718a.807.807 0 0 0-.807.805v1.175a.625.625 0 0 1-1.25 0V13.77c0-1.134.923-2.055 2.057-2.055h3.718c1.134 0 2.057.921 2.057 2.055v1.175c0 .345-.28.625-.625.625",
        clipRule: "evenodd"
      }
    )
  }
), h = e(t);
export {
  h as MembershipOptions,
  h as default
};
